/**
 * Product card interactions: variant swatch hover, link updates, quick-add.
 * Call initProductCards(root) after dynamically appending cards (e.g. infinite scroll).
 */
function initProductCards(root = document) {
  root.querySelectorAll('.product-card-wrapper:not([data-product-card-init])').forEach((productCard) => {
    productCard.setAttribute('data-product-card-init', 'true');

    const productLink = productCard.querySelector('.product-card-link');
    const productUrl = productCard.getAttribute('data-product-url');
    const variantSwatches = productCard.querySelectorAll('.variant-swatch');
    const mainImage = productCard.querySelector('.product-card-main-image');
    const secondaryImage = productCard.querySelector('.product-card-secondary-image');
    const allVariantImages = productCard.querySelectorAll('.product-card-variant-image');
    let selectedVariantId = null;

    function showVariantImage(variantImage) {
      allVariantImages.forEach((img) => {
        img.style.opacity = '0';
      });
      if (mainImage) mainImage.style.opacity = '0';
      if (secondaryImage) secondaryImage.style.opacity = '0';
      if (variantImage) variantImage.style.opacity = '1';
    }

    function restoreDefaultImages() {
      allVariantImages.forEach((img) => {
        img.style.removeProperty('opacity');
      });
      if (mainImage) mainImage.style.removeProperty('opacity');
      if (secondaryImage) secondaryImage.style.removeProperty('opacity');
    }

    variantSwatches.forEach((swatch) => {
      const variantValue = swatch.getAttribute('data-variant-value');
      const variantId = swatch.getAttribute('data-variant-id');
      const variantImage = productCard.querySelector(
        `.product-card-variant-image[data-variant-value="${variantValue}"]`
      );

      swatch.addEventListener('mouseenter', () => {
        showVariantImage(variantImage);
        selectedVariantId = variantId;
        if (productLink && variantId) {
          productLink.href = `${productUrl}?variant=${variantId}`;
        }
      });

      swatch.addEventListener('click', (e) => {
        e.stopPropagation();
        e.preventDefault();
        if (variantId) {
          window.location.href = `${productUrl}?variant=${variantId}`;
        }
      });
    });

    if (productLink) {
      productLink.addEventListener('click', (e) => {
        if (e.target.closest('.variant-swatch')) return;
        if (selectedVariantId) {
          e.preventDefault();
          window.location.href = `${productUrl}?variant=${selectedVariantId}`;
        }
      });
    }

    productCard.addEventListener('mouseleave', () => {
      restoreDefaultImages();
      selectedVariantId = null;
      if (productLink) productLink.href = productUrl;
    });

    const addToCartBtn = productCard.querySelector('[data-card-add-to-cart]');
    if (addToCartBtn) {
      addToCartBtn.addEventListener('click', async (e) => {
        e.preventDefault();
        e.stopPropagation();
        if (addToCartBtn.disabled) return;
        if (addToCartBtn.classList.contains('is-loading')) return;
        if (addToCartBtn.classList.contains('is-added')) return;

        const variantId = addToCartBtn.getAttribute('data-variant-id');
        const productTitle = addToCartBtn.getAttribute('data-product-title') || '';
        const originalAriaLabel = addToCartBtn.getAttribute('aria-label');

        if (!variantId) return;

        addToCartBtn.disabled = true;
        addToCartBtn.classList.add('is-loading');
        addToCartBtn.setAttribute('aria-busy', 'true');

        try {
          const formData = new FormData();
          formData.append('id', variantId);
          formData.append('quantity', '1');

          const response = await fetch('/cart/add.js', {
            method: 'POST',
            body: formData,
            credentials: 'same-origin',
          });

          if (!response.ok) {
            let errorMessage = 'Kon niet toevoegen aan winkelwagen.';
            try {
              const errorData = await response.json();
              if (errorData?.description) errorMessage = errorData.description;
              else if (errorData?.message) errorMessage = errorData.message;
            } catch {
              // fall through
            }
            throw new Error(errorMessage);
          }

          const data = await response.json();
          const detail = {
            sectionId: 'product-card',
            response: data,
            quantity: 1,
            productTitle,
          };
          document.dispatchEvent(new CustomEvent('cart:add', { detail }));
          document.dispatchEvent(new CustomEvent('cart:update', { detail }));
          if (typeof window.publish === 'function' && window.PUB_SUB_EVENTS) {
            window.publish(window.PUB_SUB_EVENTS.cartUpdate, detail);
          }

          addToCartBtn.classList.remove('is-loading');
          addToCartBtn.removeAttribute('aria-busy');
          addToCartBtn.classList.add('is-added');
          addToCartBtn.setAttribute('aria-label', 'Toegevoegd aan winkelwagen');
          setTimeout(() => {
            addToCartBtn.classList.remove('is-added');
            if (originalAriaLabel) addToCartBtn.setAttribute('aria-label', originalAriaLabel);
            addToCartBtn.disabled = false;
          }, 1500);
        } catch (err) {
          addToCartBtn.classList.remove('is-loading');
          addToCartBtn.removeAttribute('aria-busy');
          addToCartBtn.disabled = false;
          if (window.SpiruToast?.show) {
            window.SpiruToast.show(err.message || 'Kon niet toevoegen aan winkelwagen.');
          } else {
            console.error('[product-card] add to cart failed:', err);
          }
        }
      });
    }
  });
}

window.initProductCards = initProductCards;

document.addEventListener('DOMContentLoaded', () => initProductCards());
document.addEventListener('shopify:section:load', (event) => initProductCards(event.target));
